<template>
  <v-dialog
    v-model="opened"
    content-class="maintenance-date"
    max-width="300"
    persistent
  >
    <h3 class="maintenance-date__title">
      <span>{{ $t('common.btns.edit') }}</span>
      <template v-if="title"> - {{ title }} </template>
    </h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="rgba(255,255,255,0.6)">
        mdi-close-circle-outline
      </v-icon>
    </v-btn>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <h4 class="maintenance-date__datepicker-title">
          <span>{{ $t('common.fields.openCheckup') }}:</span>
        </h4>

        <v-date-picker
          v-model="formData.date"
          class="maintenance-date__datepicker"
          color="warning"
          header-color="#333"
          full-width
          :locale="$i18n.locale"
          :max="new Date().toISOString().substr(0, 10)"
        />

        <div class="px-2 py-2">
          <v-btn
            color="warning"
            elevation="0"
            outlined
            block
            :disabled="!formData.date"
            @click="tab++"
          >
            {{ $t('common.button.next') }}
          </v-btn>
        </div>
      </v-tab-item>

      <v-tab-item>
        <div class="maintenance-date__back">
          <v-btn
            color="rgba(255,255,255,0.6)"
            icon
            dark
            :disabled="loading"
            @click="tab--"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </div>

        <v-form
          ref="maintance-form"
          class="maintenance-date__fields"
          @submit.prevent="onSubmit"
        >
          <v-select
            v-model="formData.supplier_id"
            item-value="id"
            item-text="name"
            outlined
            dense
            :loading="suppliersLoading"
            :items="suppliers"
            :label="$t('auto.internalMaintenance.provider')"
            :rules="[isRequired]"
          />
          <v-text-field
            v-model="formData.amount"
            outlined
            dense
            :label="$t('common.fields.sum')"
            :rules="[isRequired, onlyNumbers]"
          />
          <v-text-field
            v-model="formData.tachometer"
            outlined
            dense
            :label="$t('auto.internalMaintenance.speedometerNew')"
            :rules="[isTachometer]"
          />

          <v-btn
            type="submit"
            color="warning"
            elevation="0"
            block
            :loading="loading"
          >
            {{ $t('common.btns.save') }}
          </v-btn>
        </v-form>
      </v-tab-item>
    </v-tabs-items>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    paramName: {
      type: String,
      required: true,
    },
    itemId: {
      required: true,
    },
    currentValue: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    tab: 0,
    loading: false,
    suppliersLoading: false,
    formData: {
      date: '',
      tachometer: '',
      amount: '',
      supplier_id: '',
    },
  }),
  watch: {
    opened(val) {
      if (val) {
        this.formData.date = this.currentValue;
      } else {
        this.formData = {
          date: '',
          tachometer: '',
          amount: '',
          supplier_id: '',
        };

        if (this.$refs['maintance-form']) {
          this.$refs['maintance-form'].resetValidation();
        }

        this.tab = 0;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    suppliers() {
      return this.$store.state.suppliers.list;
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    isTachometer(v) {
      if (!v) return true;

      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.tachometr')
      );
    },
    async fetchSuppliers() {
      this.suppliersLoading = true;
      await this.$store.dispatch('suppliers/fetchList', { pageRows: 99999 });
      this.suppliersLoading = false;
    },
    async onSubmit() {
      const isValid = this.$refs['maintance-form'].validate();

      if (!isValid) return;

      this.loading = true;

      const params = {
        [this.paramName]: this.formData.date,
        supplier_id: this.formData.supplier_id,
        amount: this.formData.amount,
        tachometer: this.formData.tachometer,
      };

      const result = await this.$store.dispatch(
        'auto/updateInternalMaintenanceItem',
        {
          id: this.itemId,
          params,
        },
      );

      if (result.success) this.opened = false;

      this.$emit('update', result);
      this.loading = false;
    },
  },
  created() {
    if (this.suppliers.length === 0) this.fetchSuppliers();
  },
};
</script>

<style lang="scss">
.maintenance-date {
  background-color: #fff;
  color: #333;

  .close-btn {
    top: 7px;
  }

  &__title {
    font-size: 20px;
    padding: 10px 15px;
    color: #fff;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.6);
    background-color: #333;

    span {
      opacity: 0.6;
    }
  }

  &__back {
    padding-left: 5px;
    background-color: #333;
  }

  &__datepicker {
    border-radius: 0 !important;
    box-shadow: none;

    .v-picker__title {
      padding-top: 5px;
    }

    &-title {
      color: #fff;
      background-color: #333;
      padding: 5px 15px;

      span {
        opacity: 0.6;
      }
    }
  }

  &__fields {
    padding: 20px 10px 10px;
  }
}
</style>
